import React, { useEffect, useMemo, useRef, useState } from "react";
import localVideos from "../assets/livestreaming/videos.json";

function RandomYouTubePlayer({
  videoIds,
  title = "Now Playing",
  className = "",
  autoplay = true,
  muted = true,
  deferUntilScroll = 150, // pixels of scroll before rendering
}) {
  const [shouldRender, setShouldRender] = useState(deferUntilScroll <= 0);
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (deferUntilScroll <= 0) return;
    const maybeEnable = () => {
      if (window.scrollY >= deferUntilScroll) {
        setShouldRender(true);
        window.removeEventListener("scroll", maybeEnable);
      }
    };
    window.addEventListener("scroll", maybeEnable, { passive: true });
    maybeEnable();
    return () => window.removeEventListener("scroll", maybeEnable);
  }, [deferUntilScroll]);

  useEffect(() => {
    if (shouldRender || typeof IntersectionObserver === "undefined") return;
    const target = sentinelRef.current;
    if (!target) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShouldRender(true);
            observer.disconnect();
          }
        });
      },
      { rootMargin: "200px 0px" }
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [shouldRender]);

  const videoId = useMemo(() => {
    const fallbackIds = Object.keys(localVideos || {});
    const pool = Array.isArray(videoIds) && videoIds.length ? videoIds : fallbackIds;
    if (!pool || !pool.length) return null;
    const index = Math.floor(Math.random() * pool.length);
    return pool[index];
  }, [videoIds]);

  if (!videoId || !shouldRender) {
    return <div ref={sentinelRef} className={`random-yt-placeholder ${className}`.trim()} />;
  }

  const params = new URLSearchParams({
    autoplay: autoplay ? "1" : "0",
    mute: muted ? "1" : "0",
    rel: "0",
    playsinline: "1",
    modestbranding: "1",
    controls: "1",
  });

  return (
    <div className={`random-yt-player ${className}`.trim()}>
      <h3 className="random-yt-title">{title}</h3>
      <div className="random-yt-frame">
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?${params.toString()}`}
          title="Random worship video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    </div>
  );
}

export default RandomYouTubePlayer;
